/**
 * The milestone lifecycle, shared by the Worker and both browser bundles.
 *
 * A status here is an OUTCOME, not a risk level: 'planned' until the day
 * arrives, then what actually happened. Whether a planned milestone is close,
 * overdue or short of ready is derived from its date and its linked requests
 * on every read — see src/lib/milestones.ts.
 */

export type MilestoneStatus = "planned" | "hit" | "missed" | "cancelled";

/** Every status, in the order screens list them. */
export const MILESTONE_STATUS_ORDER: MilestoneStatus[] = ["planned", "hit", "missed", "cancelled"];

/** Display labels. 'cancelled' reads as "Cancelled" rather than "Retired"
 *  because it is the customer-facing word too. */
export const MILESTONE_STATUS_LABEL: Record<MilestoneStatus, string> = {
  planned: "Planned",
  hit: "Hit",
  missed: "Missed",
  cancelled: "Cancelled",
};

/** Statuses still ahead of us — the default filter on the list screen. */
export const OPEN_MILESTONE_STATUSES: MilestoneStatus[] = ["planned"];

/** A cancelled milestone is never offered when linking, but stays on the
 *  requests that already carry it — the hidden-tag rule, so retiring one
 *  never leaves a request that cannot be saved. */
export const LINKABLE_MILESTONE_STATUSES: MilestoneStatus[] = ["planned", "hit", "missed"];
